import { ID } from "@/data/types/Basic";
import { FC, useEffect, useState } from "react";
import { useProductDetails } from "@/data/Content/ProductDetails";
import { useStoreLocatorState } from "@/data/state/useStoreLocatorState";
import { ContentProvider } from "@/data/context/content";
import { productDetailsContainerSX } from "@/components/blocks/ProductDetails/styles/container";
import { ProductDetailsGallery } from '@/components/blocks/ProductDetails/Gallery';
import { Box, Stack } from "@mui/material";

export const PdpFullImageRv: FC<{ id: ID }> = ({id}) => {
    const [physicalStoreName, setPhysicalStoreName] = useState<string>('');
    const productDetails = useProductDetails({ partNumber: id.toString(), physicalStoreName });
    const { storeLocator } = useStoreLocatorState();
    useEffect(() => {
		setPhysicalStoreName(storeLocator.selectedStore?.physicalStoreName ?? '');
	}, [storeLocator.selectedStore]);
    return productDetails && productDetails.product ? (
        <ContentProvider value={productDetails}>
			<Stack sx={productDetailsContainerSX}>
                <ProductDetailsGallery sx={{columnGap:2}}  />
            </Stack>
        </ContentProvider>      
    ):<Box minWidth='100%'></Box>;
}